module.exports = __webpack_public_path__ + "static/media/hourglass.f1a29140.gif";